export function createEntityId(cocoomAccountId, cocoomChannelRef) {
  return `${cocoomAccountId}_${cocoomChannelRef}`;
}
